import { render, staticRenderFns } from "./home-part-four.vue?vue&type=template&id=50f81881&scoped=true"
import script from "./home-part-four.vue?vue&type=script&lang=js"
export * from "./home-part-four.vue?vue&type=script&lang=js"
import style0 from "./home-part-four.vue?vue&type=style&index=0&id=50f81881&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f81881",
  null
  
)

export default component.exports